import { fromJS, Map } from 'immutable'
import * as actionTypes from './constants'
import { LOGOUT } from '../authentication/constants'

const initialState = fromJS({})

function reducer(state = initialState, action) {
  let helperVariable

  switch (action.type) {
    case actionTypes.GET_DATASET:
      return state.set('gettingDataset', true)
    case actionTypes.CLEAR_DATASET:
      return state.set('dataset', null)
    case actionTypes.GET_DATASET_DONE:
      return state.set('dataset', action.dataset).set('gettingDataset', false)
    case actionTypes.GET_DATASET_ERROR:
      return state
        .set('getDatasetError', action.error)
        .set('gettingDataset', false)

    case actionTypes.UPDATE_DATASET:
      return state.set('dataset', {
        ...state.get('dataset'),
        ...action.dataset
      })

    case actionTypes.GET_RECORDS_PAGE:
      return state.set('gettingRecordsPage', true)
    case actionTypes.CLEAR_RECORDS:
      return state.set('records', new Map())
    case actionTypes.GET_RECORDS_PAGE_DONE:
      return state
        .setIn(['records', action.page], action.recordsPage)
        .set('gettingRecordsPage', false)
    case actionTypes.GET_RECORDS_PAGE_ERROR:
      return state
        .set('getRecordsPageError', action.error)
        .set('gettingRecordsPage', false)

    case actionTypes.UPDATE_COLUMN_ERROR:
      return state.set('updateColumnError', action.error)

    case actionTypes.DEACTIVATE_RECORD_ERROR:
      return state.set('deactivateRecordError', action.error)

    case actionTypes.REPLACE_RECORD_ERROR:
      return state.set('replaceRecordError', action.error)

    case actionTypes.ADD_RECORD:
      return state.set('addingRecord', true)
    case actionTypes.ADD_RECORD_DONE:
      helperVariable = state.getIn(['records', action.page])
      helperVariable.content.unshift(action.record)
      return state
        .set('addingRecord', false)
        .setIn(['records', action.page], helperVariable)
    case actionTypes.ADD_RECORD_ERROR:
      return state
        .set('addRecordError', action.error)
        .set('addingRecord', false)

    case actionTypes.ADD_COLUMN:
      return state.set('addingColumn', true).set('addColumnError', null)
    case actionTypes.ADD_COLUMN_DONE:
      helperVariable = state.get('dataset')
      helperVariable.displayColumns.splice(1, 0, action.column)
      return state.set('dataset', helperVariable).set('addingColumn', false)
    case actionTypes.ADD_COLUMN_ERROR:
      return state
        .set('addColumnError', action.error)
        .set('addingColumn', false)
    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default reducer
